import getAppSettings from "./getAppSettings.js";

export { getAppSettings };

export default { getAppSettings };